import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import EditButton from './EditButton';
import DeleteButton from './DeleteButton';
import { Input2 } from './styles';
import { geographicCoordinatesService } from '../../../services/geographicCoordinatesService';

const Search = ({ onCloseModal, PreencheItem }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    handleSearchByDescricao(searchTerm);
  }, []);

  const handleSearchByDescricao = async (descricao) => {
    setIsLoading(true);

    try {
      const token = sessionStorage.getItem('Authorization');
      let data;

      // 🔹 Se a descrição estiver vazia, busca todas
      if (!descricao || descricao.trim() === '') {
        data = await geographicCoordinatesService.getCoordinates(token);
      }
      // 🔹 Se tiver descrição, busca por ela
      else {
        data = await geographicCoordinatesService.getCoordinatesByDescricao(descricao, token);
      }

      console.log(data);
      setSearchResults(data);

    } catch (error) {
      console.error('Erro na pesquisa:', error);
      Swal.fire({
        title: 'Erro!',
        text: 'Ocorreu um erro durante a pesquisa. Por favor, tente novamente mais tarde.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleBtnEdit = (item) => {
    setSelectedItem(item);
    PreencheItem(item);
    onCloseModal();
  };

  const handleBtnDelete = (item) => {
    onCloseModal();
  };

  const handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchByDescricao(searchTerm);
    }
  };

  return (
    <div style={{ height: '380px' }}>
      <h2>Pesquisar Coordenadas Geográficas</h2>
      <div>
        <Input2
          style={{ width: '335px' }}
          type="text"
          placeholder="Digite o termo de busca"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={handleEnterPress}
        />
        <button
          style={{
            backgroundColor: 'var(--info)',
            color: 'var(--text-primary)',
            border: 'none',
            borderRadius: '5px',
            padding: '10px 20px',
            fontSize: '16px',
            cursor: 'pointer',
          }}
          onClick={() => handleSearchByDescricao(searchTerm)}
          disabled={isLoading}
        >
          Buscar
        </button>
      </div>
      {isLoading && <p>Realizando a busca...</p>}
      <br />

      <div style={{ height: '250px', width: '440px', overflowY: 'auto' }}>
        <table style={{ width: '430px' }}>
          <thead>
            <tr style={{ background: 'var(--table-header-bg)', height: '50px', color: 'var(--table-header-color)' }}>
              <th style={{ width: '100px', padding: '10px' }}>Descrição</th>
              <th style={{ width: '90px', padding: '10px' }}>Latitude</th>
              <th style={{ width: '90px', padding: '10px' }}>Longitude</th>
              <th style={{ width: '90px', textAlign: 'center', padding: '10px' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {searchResults.map((result, index) => (
              <tr key={result.id} style={{ backgroundColor: index % 2 === 0 ? 'var(--surface-1)' : 'var(--accent-secondary)' }}>
                <td style={{ width: '100px' }}>{result.descricao}</td>
                <td>{result.latitude}</td>
                <td>{result.longitude}</td>
                <td style={{ textAlign: 'center', minWidth: '110px', maxWidth: '110px' }}>
                  <div style={{ float: 'left', marginLeft: '5px' }}><EditButton closeModal={() => handleBtnEdit(result)} /></div>
                  <div style={{ float: 'right', marginRight: '12px' }}><DeleteButton closeModal={() => handleBtnDelete(result)} id={result.id} /></div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Search;
